/** Shared course-domain picker (Quiz My Titles + Presentation Maker slide picker). */

export const CATALOGUE_FAVORITE_KEY = "microlab.courseCatalog.favoriteCatalogue";

export const SYSTEM_CATALOGUE_OPTIONS = [
  { key: "all", title: "All", apiTypes: ["his", "emb", "anatomy"] },
  { key: "histology", title: "Histology", apiTypes: ["his"] },
  { key: "embryology", title: "Embryology", apiTypes: ["emb"] },
  { key: "anatomy", title: "Anatomy", apiTypes: ["anatomy"] },
];

export const SPECIFIC_CATALOGUE_OPTIONS = SYSTEM_CATALOGUE_OPTIONS.filter(
  (o) => o.key !== "all"
);

export function readFavoriteCatalogueKey(fallback = "histology") {
  try {
    const fav = localStorage.getItem(CATALOGUE_FAVORITE_KEY) || fallback;
    return SYSTEM_CATALOGUE_OPTIONS.some((o) => o.key === fav) ? fav : fallback;
  } catch (_) {
    return fallback;
  }
}

export function writeFavoriteCatalogueKey(key) {
  const next = SYSTEM_CATALOGUE_OPTIONS.some((o) => o.key === key)
    ? key
    : "histology";
  try {
    localStorage.setItem(CATALOGUE_FAVORITE_KEY, next);
  } catch (_) {
    /* ignore */
  }
  return next;
}

export function catalogueOptionByKey(key) {
  return SYSTEM_CATALOGUE_OPTIONS.find((o) => o.key === key) || null;
}

export function apiTypeToSourceLabel(apiType) {
  if (apiType === "his") return "Histology";
  if (apiType === "emb") return "Embryology";
  if (apiType === "anatomy") return "Anatomy";
  return "Course";
}
